const fb = require('../../firebaseConfig.js')

export default {
    state: {
        providers: [],
		provider: {},
    },
    getters: {
        provider: (state) => {
			return state.provider
        },
        providers: (state) => {
            return state.providers
        }
    },
    mutations: {
        setProviders(state,val) {
			state.providers = val
		},
		setProvider(state, val) {
			state.provider = val
		},
    },
    actions: {
        async fetchProviders({commit}) {
            await fb.providersCollection.onSnapshot(querySnapshot => {
                let providers = []
                querySnapshot.forEach(provider => {
                    let providerEdited = provider.data()
                    providerEdited.id = provider.id
                    providers.push(providerEdited)
                })
                commit('setProviders', providers)
            })
        },
        async fetchProvider({commit}, {providerId}) {
            await fb.providersCollection.doc(providerId).get().then(res => {
                let currentProvider = res.data()
                if (currentProvider.materials == undefined) {
                    currentProvider.materials = []
                }
                currentProvider.id = providerId
                commit('setProvider', currentProvider)
            })
        },
        createProvider({getters}, payload) {
            if(payload.id) {
                console.log(payload)
                fb.providersCollection.doc(payload.id).set({
                    idNumber: payload.idNumber,
                    name: payload.name,
                    address: payload.address,
                    code: payload.code,
                    contactName: payload.contactName,
                    contactEmail: payload.contactEmail,
                    contactTitle: payload.contactTitle,
                    totalCredit: payload.totalCredit,
                    materials: payload.materials,
                    updatedOn: fb.fromDate(new Date()),
                    updatedBy: getters.userId
                })
                return
            }
            fb.providersCollection.add({
                idNumber: payload.idNumber,
                code: payload.code,
                name: payload.name,
                address: payload.address,
                contactName: payload.contactName,
                contactEmail: payload.contactEmail,
                contactTitle: payload.contactTitle,
                totalCredit: payload.totalCredit,
                materials: payload.materials,
                createdOn: fb.fromDate(new Date()),
                createdBy: getters.userId
            })
        }
    }
}